import { environment } from '@bvl-admin/environments/environment';

export class ComponentEndpoint {
  public static componentsPagination = `${environment.LOAD_BALANCER}/trays/component/valuesCommon/list`;
  public static componentByCode = `${environment.LOAD_BALANCER}/trays/component/get/{componentCode}`;
  public static componentValue = `${environment.LOAD_BALANCER}/trays/component/commonValue/get/{componentCode}`;
  public static componentValueById = `${environment.LOAD_BALANCER}/trays/component/valueCommon/{componentCode}`;
  public static componentListByType = `${environment.LOAD_BALANCER}/trays/component/list/type/{type}`;
  public static saveComponentValue = `${environment.LOAD_BALANCER}/trays/component/save/valuecommon`;
  public static saveComponentValueById = `${environment.LOAD_BALANCER}/trays/component/save/valuecommon/id`;
}
